import _ from 'lodash';
import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';

import SongListHeadings from './song-list-headings';
import SongRow from './song-row';

@inject('songsStore')
@observer
class SongList extends Component {
	render () {
		const { songsStore, listKey, songList, optionsTheme } = this.props;
		const collection = _.isEmpty(songList) ? _.get(songsStore, listKey) : songList;

		if (_.isEmpty(collection)) {

			return null;
		}

		return (
			<div className="song-list">
				<SongListHeadings />

				{
					collection.map(
						(song, index) =>
							<SongRow
								optionsTheme={ optionsTheme }
								key={ song._id }
								index={ index }
								song={ song }
								songID={ song._id }
								songsStore={ songsStore } />
					)
				}
			</div>
		);
	}
}

export default SongList;
